import Axios from 'axios';
import { Payload } from '../constants/payload.model';
let RESOURCE_GET_BY_EMAIL = '/Integration/member'

const MEMBERPROFILE_API = `${process.env.VUE_APP_MEMBERPROFILE_API}`;

const apiProxy = (options) => {
    try {
        return Axios.post('/ProxyApi', options);
    } catch (error) {
        throw new Error(error);
    }
};


export default {

    async getMemberStatus(memberId) {

        const options = new Payload(`${MEMBERPROFILE_API}/member/${memberId}`, 'GET');

        const response = await apiProxy(options);
        const data = await response.data;
        return data;
    },

    getMemberByEmail(email) {
        return Axios.get(`${RESOURCE_GET_BY_EMAIL}?email=${email}`);
    }
}